/**
 * Helpers for Auth factory methods
 */

import type { IBaseApiService } from "../../../BaseApiServiceFactory";
import type {
	ICustomerTokens,
	IMailVerifyParams,
	IMailVerifyReturn,
	IVerifyTotpCodeParams,
	IVerifyTotpCodeReturn,
	ISetPasswordParams,
	ILoginParams,
	IAskNewPasswordParams,
	IAskAnotherCodeParams,
	IAskAnotherCodeReturn,
} from "../Auth";

/**
 * Create mail verify SMS method
 */
export function createMailVerifySmsMethod(baseApi: IBaseApiService, baseUrl: string) {
	return async (body: IMailVerifyParams): Promise<IMailVerifyReturn> => {
		const url = new URL(baseUrl.concat("/mail/verify-sms"));
		try {
			return await baseApi.postRequest<IMailVerifyReturn>(url, body);
		} catch (err) {
			baseApi.onError(err);
			return Promise.reject(err);
		}
	};
}

/**
 * Create verify TOTP code method
 */
export function createVerifyTotpCodeMethod(baseApi: IBaseApiService, baseUrl: string) {
	return async (body: IVerifyTotpCodeParams): Promise<IVerifyTotpCodeReturn> => {
		const url = new URL(baseUrl.concat("/verify-totp-code"));
		try {
			return await baseApi.postRequest<IVerifyTotpCodeReturn>(url, body);
		} catch (err) {
			baseApi.onError(err);
			return Promise.reject(err);
		}
	};
}

/**
 * Create set password method
 */
export function createSetPasswordMethod(baseApi: IBaseApiService, baseUrl: string) {
	return async (body: ISetPasswordParams): Promise<ICustomerTokens> => {
		const url = new URL(baseUrl.concat("/set-password"));
		try {
			return await baseApi.postRequest<ICustomerTokens>(url, body);
		} catch (err) {
			baseApi.onError(err);
			return Promise.reject(err);
		}
	};
}

/**
 * Create login method
 */
export function createLoginMethod(baseApi: IBaseApiService, baseUrl: string) {
	return async (body: ILoginParams): Promise<ICustomerTokens> => {
		const url = new URL(baseUrl.concat("/login"));
		try {
			return await baseApi.postRequest<ICustomerTokens>(url, body);
		} catch (err) {
			baseApi.onError(err);
			return Promise.reject(err);
		}
	};
}

/**
 * Create ask new password method
 */
export function createAskNewPasswordMethod(baseApi: IBaseApiService, baseUrl: string) {
	return async (body: IAskNewPasswordParams): Promise<IMailVerifyReturn> => {
		const url = new URL(baseUrl.concat("/ask-new-password"));
		try {
			return await baseApi.postRequest<IMailVerifyReturn>(url, body);
		} catch (err) {
			baseApi.onError(err);
			return Promise.reject(err);
		}
	};
}

/**
 * Create send another code method
 */
export function createSendAnotherCodeMethod(baseApi: IBaseApiService, baseUrl: string) {
	return async (body: IAskAnotherCodeParams): Promise<IAskAnotherCodeReturn> => {
		const url = new URL(baseUrl.concat("/send-another-code"));
		try {
			return await baseApi.postRequest<IAskAnotherCodeReturn>(url, body);
		} catch (err) {
			baseApi.onError(err);
			return Promise.reject(err);
		}
	};
}

/**
 * Create logout method
 */
export function createLogoutMethod(baseApi: IBaseApiService) {
	return async (): Promise<{ message: string }> => {
		const url = new URL(baseApi.getBaseUrl().concat("/auth/logout"));
		try {
			return await baseApi.postRequest<{ message: string }>(url, {});
		} catch (err) {
			baseApi.onError(err);
			return Promise.reject(err);
		}
	};
}
